import React from 'react';
import { ArrowLeftIcon, HardHatIcon } from 'lucide-react';
type ComingSoonProps = {
  title: string;
  breadcrumb?: string;
};
export function ComingSoon({
  title,
  breadcrumb
}: ComingSoonProps) {
  return <div className="w-full min-h-[60vh] flex flex-col items-center justify-center px-4 py-20" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-62">
      <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6" style={{
      backgroundColor: 'rgba(200,168,75,0.15)'
    }} data-id="element-63">
        <HardHatIcon size={32} style={{
        color: '#c8a84b'
      }} data-id="element-64" />
      </div>

      {breadcrumb && <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
      color: '#c8a84b',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-65">
          {breadcrumb}
        </p>}

      <h1 className="text-3xl md:text-4xl font-bold uppercase text-center mb-4" style={{
      fontFamily: 'Oswald, sans-serif',
      color: '#1e3d2f'
    }} data-id="element-66">
        {title}
      </h1>

      <div className="w-12 h-1 rounded-full mb-6" style={{
      backgroundColor: '#c8a84b'
    }} data-id="element-67" />

      <p className="text-base text-center max-w-md mb-8" style={{
      color: '#4a6a5a',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-68">
        This page is coming soon. We're working on bringing you the best
        content. Check back shortly!
      </p>

      <a href="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
      backgroundColor: '#1e3d2f',
      color: '#ffffff',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-69">
        <ArrowLeftIcon size={15} data-id="element-70" />
        Back to Home
      </a>
    </div>;
}